{
  "header": {
    "title": "Umfrageübersicht",
    "description": "Erstellen, verwalten und analysieren Sie Mitarbeiterumfragen, um tiefere Einblicke zu gewinnen",
    "createButton": "Umfrage erstellen",
    "createModal": {
      "title": "Umfrage erstellen",
      "useTemplate": {
        "title": "Vorlagen verwenden",
        "description": "Erkunden Sie vorgefertigte Vorlagen und passen Sie sie an Ihre Ziele an",
        "buttonLabel": "Vorlagen ansehen"
      },
      "createTemplate": {
        "title": "Von Grund auf neu erstellen",
        "description": "Erstellen Sie Ihre einzigartige Umfrage mit dem gewünschten Format",
        "buttonLabel": "Umfrage erstellen"
      }
    },
    "unsavedChangesDialog": {
      "title": "Ungespeicherte Umfrageänderungen",
      "description": "Sie haben ungespeicherte Änderungen, die verloren gehen, wenn Sie diese Seite verlassen. Möchten Sie ohne Speichern fortfahren?",
      "exitButton": "Ohne Speichern beenden",
      "keepEditingButton": "Weiter bearbeiten"
    }
  },
  "tabs": {
    "active": "Aktiv",
    "finished": "Abgeschlossen",
    "scheduled": "Geplant",
    "drafts": "Entwürfe"
  },
  "searchInput": {
    "placeholder": "Umfragen suchen"
  },
  "tagsDropdown": {
    "triggerLabel": "Tags",
    "placeholder": "Tag finden",
    "options": {
      "employeeEngagement": "Mitarbeiterengagement",
      "workplaceCulture": "Arbeitsplatzkultur",
      "teamSatisfaction": "Teamzufriedenheit",
      "performanceFeedback": "Leistungsfeedback",
      "organizationalImprovement": "Organisationsverbesserung",
      "usa": "USA",
      "europe": "Europa",
      "asia": "Asien",
      "ukraine": "Ukraine"
    }
  },
  "builderPage": {
    "header": {
      "title": "Umfrage-Builder",
      "backButton": "Zurück",
      "seePreviewButton": "Vorschau ansehen",
      "shareButton": "Teilen",
      "saveButton": {
        "label": "Speichern",
        "options": {
          "draft": "Als Entwurf speichern",
          "template": "Als Vorlage speichern",
          "companyTemplate": "Als Firmenvorlage speichern"
        }
      },
      "publishButton": "Veröffentlichen"
    },
    "tabs": {
      "surveySetup": {
        "title": "Umfrage-Einrichtung",
        "coverImageSection": {
          "title": "Titelbild",
          "imageUpload": "Bild hochladen oder hier ablegen",
          "imageSize": "Max. 800x400 px",
          "formatImage": "PNG-, JPG-Format",
          "titleInput": {
            "label": "Umfragetitel",
            "placeholder": "Titel eingeben"
          },
          "descriptionInput": {
            "label": "Umfragebeschreibung",
            "placeholder": "Beschreibung eingeben"
          },
          "tagsInput": {
            "label": "Umfrage-Tags",
            "placeholder": "Tag eingeben und Enter drücken"
          }
        },
        "question": {
          "title": "Frage #{{questionCount}}",
          "required": "Erforderlich",
          "type": {
            "title": "Fragetyp",
            "textType": "Text",
            "scaleType": "Skala",
            "choiceType": "Auswahl"
          },
          "questionInput": {
            "label": "Frage",
            "placeholder": "Frage hier eingeben"
          },
          "descriptionInput": {
            "label": "Fragebeschreibung",
            "placeholder": "Beschreibung hier eingeben"
          },
          "span": {
            "title": "Bereich",
            "to": "bis"
          },
          "spanLabels": {
            "title": "Bereichsbezeichnungen",
            "placeholder": "Bezeichnung (optional)"
          },
          "options": {
            "title": "Auswahlmöglichkeiten",
            "placeholder": "Wahl eingeben",
            "addChoiceButton": "Wahl hinzufügen",
            "multipleAnswers": "Mehrere Antworten"
          },
          "addNewQuestionBUtton": "Neue Frage hinzufügen"
        },
        "cardPreview": {
          "title": "Umfrage-Kartenvorschau",
          "tabs": {
            "cover": {
              "label": "Titel",
              "time": "1-2 Minuten"
            },
            "template": {
              "label": "Vorlage",
              "time": "1-2 Minuten"
            }
          }
        }
      },
      "audience": {
        "title": "Zielgruppe",
        "audienceSection": {
          "title": "Größe der Zielgruppe"
        },
        "surveyAudienceSection": {
          "title": "Umfrage-Zielgruppe",
          "options": {
            "entireCompany": "Gesamtes Unternehmen"
          }
        },
        "segmentationSection": {
          "title": "Segmentierungsoptionen",
          "selectAll": "Alle auswählen",
          "options": {
            "location": {
              "label": "Standort",
              "options": {
                "us": "USA",
                "europe": "Europa",
                "asia": "Asien"
              }
            },
            "department": {
              "label": "Abteilung",
              "options": {
                "executiveTeam": "Führungsteam",
                "technicalTeam": "Technisches Team",
                "designTeam": "Designteam",
                "productTeam": "Produktteam",
                "salesTeam": "Vertriebsteam",
                "marketingTeam": "Marketingteam",
                "financeTeam": "Finanzteam"
              }
            },
            "gender": {
              "label": "Geschlecht",
              "options": {
                "male": "Männlich",
                "female": "Weiblich"
              }
            },
            "tenure": {
              "label": "Betriebszugehörigkeit",
              "options": {
                "lessThanHalf": "<0,5 Jahre",
                "halfToOne": "0,5–1 Jahr",
                "oneToTwo": "1–2 Jahre",
                "twoToFive": "2–5 Jahre",
                "moreThanFive": "5+ Jahre"
              }
            }
          }
        },
        "distributionSection": {
          "title": "Verteilungsmethoden",
          "options": {
            "mail": "Automatisierte E-Mail",
            "link": "Manuelles Teilen des Links"
          }
        }
      },
      "delivery": {
        "title": "Lieferung",
        "startDate": {
          "label": "Startdatum",
          "placeholder": "Datum auswählen"
        },
        "endDate": {
          "label": "Enddatum",
          "closeAfter": "Schließen nach",
          "days": "Tagen",
          "closeButton": "Nicht automatisch schließen"
        }
      },
      "translation": {
        "title": "Übersetzung",
        "tabs": {
          "info": {
            "label": "Info"
          },
          "question": {
            "label": "Frage {{questionCount}}"
          }
        }
      }
    }
  },
  "preview": {
    "header": {
      "backButton": "Umfragevorschau",
      "publishButton": "Veröffentlichen"
    },
    "question": {
      "finishSurvey": "Umfrage abschließen",
      "nextQuestion": "Nächste Frage",
      "previousQuestion": "Vorherige Frage"
    }
  },
  "columns": {
    "title": "Titel",
    "tags": "Stichwörter",
    "noTags": "Keine Stichwörter",
    "completionRate": "Abschlussrate",
    "scheduledDate": "Geplantes Datum",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "creator": "Ersteller"
  },

  "detailsPage": {
    "header": {
      "backButton": "Zur Umfrageübersicht zurück",
      "exportButton": "Exportieren"
    },
    "surveyOverviewSection": {
      "title": "Umfrageübersicht",
      "invitedBlock": {
        "title": "Eingeladen",
        "usersCount": "{{usersCount}} Benutzer"
      },
      "responsesBlock": {
        "title": "Antworten"
      },
      "info": {
        "creator": "Ersteller",
        "startDate": "Startdatum",
        "endDate": "Enddatum",
        "segmentation": "Segmentierung",
        "distributionMethod": "Verteilungsmethode"
      }
    },
    "question": {
      "questionCount": "Frage #{{questionCount}}",
      "responseCount": "{{responseCount}} Antworten"
    },
    "asnwersSection": {
      "title": "Antworten"
    }
  }
}
